import { api } from "constants/RotasAPI";
import { useMutation } from "react-query";
import { http } from "shared/util/http";
import { ValoresDespesaParceladaRequest } from "types/request/contasPagar/ValoresDespesaParceladaRequest";
import { ValoresDespesaParceladaResponse } from "types/request/contasPagar/ValoresDespesaParceladaResponse";
import { Cond21CloudResponse } from "types/response/Cond21CloudResponse";

const calcularValoresDespesaParcelada = async (
  dadosRequisicao: ValoresDespesaParceladaRequest
): Promise<Cond21CloudResponse<ValoresDespesaParceladaResponse[]>> => {
  const { data } = await http.post<Cond21CloudResponse<ValoresDespesaParceladaResponse[]>>(
    api.contasPagar.postCalcularValoresDespesaParcelada,
    dadosRequisicao
  );
  return data;
};

export const usePostCalcularValoresDespesaParcelada = () => {
  return useMutation<Cond21CloudResponse<ValoresDespesaParceladaResponse[]>, Error, ValoresDespesaParceladaRequest>({
    mutationFn: calcularValoresDespesaParcelada,
  });
};
